<template>
  <div class="forget-bga" v-show="isForget || isPasSeccess">
    <div class="forget-boxs" v-show="isForget">
      <div><a class="login-close" @click="closeBtn"></a></div>
      <a-tabs :animated="false" default-active-key="1" @change="callback">
        <a-tab-pane key="1" :tab="$t('login_手机号找回')">
          <div class="forget-title">{{$t('login_重置登录密码')}}</div>
          <a-input
            :placeholder="$t('common_home_enter_mobile')"
            @keyup="phoneNum = phoneNum.replace(/[^\d]/g, '')"
            :maxLength="Number(num)"
            class="login-input"
            style="margin-top:20px;"
            v-model="phoneNum"
          >
            <a-select
              slot="addonBefore"
              :value="countryCode | disCountryCode"
              style="width: 100px;font-size:14px;"
              :dropdownMatchSelectWidth="false"
              :dropdownStyle="{width:'360px'}"
              @select="changeInternational"
            >
              <a-select-option
                v-for="(item, index) in countryCodeList"
                :value="item.id"
                :key="item.phonecode+index"
              >
                <div slot="div" style="display:flex;justify-content:space-between;">
                  <span slot="span">{{item['name' + currentLangList[currentLang]]}}</span>
                  <span slot="span">+ {{item.phonecode}}</span>
                </div>
              </a-select-option>
            </a-select>
          </a-input>
          <div class="forget-very">
            <a-input :placeholder="$t('login_请输入右侧验证码')" :maxLength="Number(veryCodeLength)" class="login-input" style="margin-top:20px;" v-model="veryCodeInput" />
            <img class="forget-avatar" :src="bestCode" @click="veryCodeAvatar" alt="" />
          </div>
          <div class="forget-message">
            <a-input :placeholder="$t('common_home_enter_message_code')" class="login-input" style="margin-top:20px;" v-model="veryCodePhone" />
            <i class="forget-veryBtn" v-show="sendMsgDisabled" @click="toCaptcha">{{$t('common_btn_send_ver')}}</i>
            <i class="forget-veryBtn" v-show="!sendMsgDisabled">{{codeTime}} s</i>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('common_home_user_email_back')" force-render>
          <a-input :placeholder="$t('childAct_请输入邮箱')" class="login-input" style="margin-top:20px;" v-model="email" />
          <div class="forget-message">
            <a-input :placeholder="$t('common_home_enter_email_vercode')" class="login-input" style="margin-top:20px;" v-model="veryCodePhone" />
            <i class="forget-veryBtn" v-show="show" @click="toCaptcha">{{$t('common_btn_send_ver')}}</i>
            <i class="forget-veryBtn" v-show="!show">{{count}} s</i>
          </div>
        </a-tab-pane>
      </a-tabs>
       <a-input-password :placeholder="$t('common_home_enter_email_address_format_numbers')" class="login-input" style="margin-top:20px;" v-model="pwNum" />
       <a-input-password :placeholder="$t('login_请再次输入登录密码')" class="login-input" style="margin-top:20px;" v-model="morepwNum" />
       <a-button type="primary" class="btn" @click="loginUsPassBtn">
            {{$t('common_btn_confirm')}}
        </a-button>
        <div class="forget-login" @click="tologin">{{$t('common_login_return_user_login')}}</div>
    </div>
    <div class="forget-boxs seccess-box" v-show="isPasSeccess">
      <div><a class="login-close" @click="closeBtn"></a></div>
      <img src="../assets/o1.png" alt="" />
      <div class="seccess-happed">{{$t('common_home_user_successful')}}</div>
      <div class="seccess-text">{{$t('common_home_user_information_safe')}}</div>
      <div class="reg-btn" @click="tologin">{{$t('common_home_user_immediately')}}</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { LoginCodeAvatar, SendRetrievePassCore, PhoneCodeInterface, RetrievePassByPhone, RetrievePassByEmail, RendRetrievePassEmail } from '@/api/login'
import { mapState, mapMutations } from 'vuex'
import { openNotificationWithIcon, debounce } from '@/utils/util'

export default {
  name: 'isLogin',
  data () {
    return {
      phoneNum: '',
      num: 11,
      veryCodeLength: 4,
      passWorld: '',
      bestCode: '',
      codeTime: 0,
      sendMsgDisabled: true,
      show: true, // 验证码开关
      count: 0,
      timer: '',
      timerInterval: '',
      imgCodeKey: '',
      veryCodeInput: '',
      veryCodePhone: '',
      pwNum: '',
      morepwNum: '',
      email: '',
      isKey: '1',
      countryCode: ' 86',
      currentLangList: {
        'en_US': '',
        'zh_CN': '_zh'
      },
      countryCodeList: [
        { name_zh: '中国大陆', numcode: '156', iso: 'CN', name: 'CHINA', nicename: 'China', phonecode: '86', id: '44', sort: '9999', iso3: 'CHN' },
        { name_zh: '中国香港', numcode: '344', iso: 'HK', name: 'HONG KONG', nicename: 'Hong Kong', phonecode: '852', id: '96', sort: '9998', iso3: 'HKG' },
        { name_zh: '中国澳门', numcode: '446', iso: 'MO', name: 'MACAO', nicename: 'Macao', phonecode: '853', id: '125', sort: '9997', iso3: 'MAC' },
        { name_zh: '中国台湾', numcode: '158', iso: 'TW', name: 'TAIWAN, PROVINCE OF CHINA', nicename: 'Taiwan, Province of China', phonecode: '886', id: '208', sort: '9996', iso3: 'TWN' },
        { name_zh: '美国', numcode: '840', iso: 'US', name: 'UNITED STATES', nicename: 'United States', phonecode: '1', id: '226', sort: '9995', iso3: 'USA' },
        { name_zh: '澳大利亚', numcode: '36', iso: 'AU', name: 'AUSTRALIA', nicename: 'Australia', phonecode: '61', id: '13', sort: '9993', iso3: 'AUS' },
        { name_zh: '英国', numcode: '826', iso: 'GB', name: 'UNITED KINGDOM', nicename: 'United Kingdom', phonecode: '44', id: '225', sort: ' 9993', iso3: 'GBR' }
      ]
    }
  },
  components: {
    // HelloWorld
  },
  computed: {
    ...mapState({
      'isForget': state => state.isLogin.isForget,
      'currentLang': state => state.isLogin.lang,
      'isPasSeccess': state => state.isLogin.isPasSeccess
    })
  },
  created () {
    LoginCodeAvatar({}).then((res) => {
      this.bestCode = res.data.imgCodeData
      this.imgCodeKey = res.data.imgCodeKey
    })
    this._PhoneCodeInterface()
  },
  filters: {
    disCountryCode (val) {
      return `+ ${val}`
    }
  },
  methods: {
    ...mapMutations(['OFF_LOGIN', 'ON_LOGIN', 'SECCESS_FINDPASS']),
    tologin () {
      this.ON_LOGIN('login')
      this.phoneNum = ''
      this.veryCodeInput = ''
      this.veryCodePhone = ''
      this.pwNum = ''
      this.morepwNum = ''
      this.email = ''
    },
    callback (key) {
      this.isKey = key
      this.phoneNum = ''
      this.veryCodeInput = ''
      this.veryCodePhone = ''
      this.pwNum = ''
      this.morepwNum = ''
      this.email = ''
    },
    closeBtn () {
      this.OFF_LOGIN()
      this.phoneNum = ''
      this.veryCodeInput = ''
      this.veryCodePhone = ''
      this.pwNum = ''
      this.morepwNum = ''
    },
    // 区号
    _PhoneCodeInterface () {
      PhoneCodeInterface({}).then(({ data }) => { // 区号
        this.countryCodeList = JSON.parse(data.result)
      })
        .finally(() => {
          this.countryCode = this.countryCodeList[0].phonecode
        })
    },
    // 区号选择
    changeInternational (val, event) {
      this.countryCodeList.forEach((item) => {
        if (item.id === val) {
          this.countryCode = item.phonecode
        }
      })
    },
    loginUsPassBtn () {
      if (this.pwNum === '') return openNotificationWithIcon(`${this.$t('authority_account_passwords')}!`)
      if (this.morepwNum === '') return openNotificationWithIcon(`${this.$t('common_home_enter_email_address_format_again')}!`)
      if (this.pwNum.length < 8 || this.pwNum.length > 16) return openNotificationWithIcon(`${this.$t('common_home_enter_email_address_format_numbers')}!`)
      if (this.pwNum !== this.morepwNum) return openNotificationWithIcon(`${this.$t('authority_account_passwords')}!`)
      if (this.veryCodePhone === '') return openNotificationWithIcon(`${this.$t('common_home_enter_new_verCode')}!`)

      if (this.isKey === '1') {
        if (!this.veryCodeInput) return openNotificationWithIcon(`${this.$t('authority_account_four_verCode')}!`)
        if (this.phoneNum === '') return openNotificationWithIcon(`${this.$t('common_home_enter_mobile')}`)
        // 手机号找回
        let data = {
          phoneCode: this.countryCode,
          phone: this.phoneNum,
          shortMessageCode: this.veryCodePhone,
          password: this.morepwNum,
          systemCode: 'OPEN_API_PORTAL'
        }
        RetrievePassByPhone(data).then((res) => {
          if (res.code === '200') {
            this.SECCESS_FINDPASS(true)
          } else {
            openNotificationWithIcon(res.message)
          }
        })
      } else {
        if (this.email === '') return openNotificationWithIcon(this.$t('childAct_请输入邮箱'))
        // 邮箱找回
        let data = {
          email: this.email,
          emailCode: this.veryCodePhone,
          password: this.morepwNum,
          systemCode: 'OPEN_API_PORTAL'
        }
        RetrievePassByEmail(data).then((res) => {
          if (res.code === '200') {
            this.SECCESS_FINDPASS(true)
          } else {
            openNotificationWithIcon(res.message)
          }
        })
      }
    },
    // 获取图形验证码
    veryCodeAvatar () {
      debounce(() => {
        LoginCodeAvatar({}).then((res) => {
          this.bestCode = res.data.imgCodeData
          this.imgCodeKey = res.data.imgCodeKey
        })
      }, 600)
    },
    // 发送验证码
    toCaptcha () {
      // this.$router.push({ path: '/home' })
      if (this.isKey === '1') {
        if (this.countryCode === 86 && this.phoneNum.length !== 11) return openNotificationWithIcon(this.$t('common_home_user_mobile_phone3'))
        if (this.phoneNum.length === '') return openNotificationWithIcon(this.$t('common_home_enter_mobile'))
        if (this.veryCodeInput.length !== 4) return openNotificationWithIcon(this.$t('common_home_user_four_digit'))
        if (this.veryCodeInput === '') return openNotificationWithIcon(this.$t('common_home_enter_message_code'))
        let data = {
          imgCodeKey: this.imgCodeKey,
          imgCode: this.veryCodeInput,
          phone: this.phoneNum,
          phoneCode: this.countryCode,
          systemCode: 'OPEN_API_PORTAL'
        }
        SendRetrievePassCore(data).then((res) => {
          if (res.code === '200') {
            this.codeInterval()
          } else if (res.code !== '200') {
            this.veryCodeAvatar()
            openNotificationWithIcon(res.message)
          }
        })
      } else if (this.isKey === '2') {
        const regEmail = /^.+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (this.email !== null && this.email !== undefined && this.email !== 'undefined' && this.email !== '' && !regEmail.test(this.email)) {
          openNotificationWithIcon(this.$t('common_home_enter_email_address_format_incorrect'))
          return false
        }
        if (this.email === '') return openNotificationWithIcon(this.$t('childAct_请输入邮箱'))
        let data = {
          email: this.email,
          emailTextCode: 'PORTAL_RETRIEVE_PASSE_MAIL',
          systemCode: 'OPEN_API_PORTAL'
        }
        RendRetrievePassEmail(data).then((res) => {
          if (res.code === '200') {
            this.veryCode()
          } else {
            openNotificationWithIcon(res.message)
          }
        })
      }
    },
    // 验证码
    veryCode () {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    codeInterval () {
      const TIME_COUNT = 60
      if (!this.timerInterval) {
        this.codeTime = TIME_COUNT
        this.sendMsgDisabled = false
        this.timerInterval = setInterval(() => {
          if (this.codeTime > 0 && this.codeTime <= TIME_COUNT) {
            this.codeTime--
          } else {
            this.sendMsgDisabled = true
            clearInterval(this.timerInterval)
            this.timerInterval = null
          }
        }, 1000)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.forget-bga {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.26);
  z-index: 9;
  color: #fff;
  text-align: center;
}
.forget-boxs {
  width:470px;
  // height:351px;
  position: absolute;
  left: 50%;
  top:50%;
  transform:translate(-50%,-50%);
  background:rgba(255,255,255,1);
}
.forget-title {
  margin: 0 auto;
  width:360px;
  height:26px;
  line-height: 26px;
  font-size:14px;
  color: #4978D6;
  background:rgba(73,120,214,0.1);
  border:1px solid rgba(73,120,214,0.19);
}
.forget-very {
  position: relative;
  .forget-avatar {
    position: absolute;
    right: 68px;
    top: 26px;
    width: 64px;
    height: 37px;
    background: #ccc;
    cursor: pointer;
    box-shadow: none;
  }
}
.forget-login {
  margin-top: 23px;
  font-size:12px;
  color: #4978D6;
  cursor: pointer;
  text-align: center;
  margin-bottom: 39px;
}
.login-input {
  width:360px;
  height:48px;
}
.forget-message {
  position: relative;
  .forget-veryBtn {
    cursor: pointer;
    // background-color: #daf8eb;
    padding: 14px 16px;
    color: #4478D6;
    position: absolute;
    right: 50px;
    top: 20px;
    font-style:normal;
  }
}
.seccess-box {
  width: 343px;
  img {
    margin-top: 81px;
    width: 88px;
    height: 88px;
  }
  .seccess-happed {
    margin-top: 22px;
    font-size:18px;
    color: #282828;
  }
  .seccess-text {
    margin-top: 16px;
    font-size:14px;
    color: #989898;
  }
  .reg-btn {
    cursor: pointer;
    margin: 0 auto;
    margin-top: 16px;
    font-size:16px;
    width:165px;
    height:36px;
    line-height: 36px;
    margin-bottom: 83px;
    border-radius: 4px;
    color: #fff;
    background: #4478D6;
  }
  .reg-work-btn {
    margin: 0 auto;
    cursor: pointer;
    font-size:16px;
    width:165px;
    height:36px;
    margin-top: 16px;
    margin-bottom: 83px;
    line-height: 36px;
    border-radius:4px;
    color: #4478D6;
    border:1px solid #4478D6;
  }
}
.login-close {
  position: absolute;
  right: 29px;
  top: 15px;
  width: 31px;
  height: 20px;
  z-index: 99;
}
.login-close:before, .login-close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 12px;
  width: 2px;
  background-color: #999999;
  cursor: pointer;
}
.login-close:before {
  transform: rotate(45deg);
}
.login-close:after {
  transform: rotate(-45deg);
}
.btn {
 margin-top: 26px;
 width:360px;
 height:48px;
 font-size:16px;
}
.more-option {
  width: 360px;
  margin: 0 auto;
  margin-top: 23px;
  display: flex;
  margin-bottom: 48px;
  justify-content: space-between;
  align-items: center;
  span {
    cursor: pointer;
    font-weight:400;
    font-size: 12px;
    &:nth-child(1) {
      color: #555555;
    }
    &:nth-child(2) {
      color: #4978D6;
    }
  }
}
.login-agreement {
  text-align: left;
  margin-left: 51px;
  margin-top: 20px;
  font-size:12px;
  cursor: pointer;
  span {
    color: #4978D6;
  }
}
.forget-boxs /deep/ .ant-input {
  height:48px;
}
</style>
